import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "$isHiddenFor", "responsive", "use"];
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import { useUserOwnsPlaylist } from '../savedItemsQueries';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditPlaylistButton = _ref => {
  let {
      playlistId,
      $isHiddenFor,
      responsive,
      use = 'link'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownedByUser = useUserOwnsPlaylist(playlistId);
  const {
    matches
  } = useMediaQuery($isHiddenFor);
  if (!ownedByUser || matches) return null;
  const onEditPlaylistClick = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'edit-details-click',
      playlistId
    });
  };
  return /*#__PURE__*/_jsx(RouterButton, Object.assign({}, props, {
    onClick: onEditPlaylistClick,
    responsive: responsive,
    to: `${MY_PLAYLISTS_URL_FRAGMENT}/${playlistId}/edit-playlist`,
    use: use,
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.editDetails"
      })
    })
  }));
};